import language from '@hkgai/i18n-lang-packs/lib/government_meeting_fe_language.json';

import language_h5 from './language_h5.json';

const i18n: { [key: string]: any } = {
  'en-US': {
    ...(language['en-US'] || {}),
    meeting_type_general: 'General Meeting',
    meeting_type_social_media: 'Social Media',
    meeting_type_government_gazette: 'Government Gazette',
    upload_audio: 'Upload audio/video',
    record_audio: 'Record audio',
    transcribe_audio: 'Real-time Interpretation',
    start: 'Start',
    meeting_name_placeholder: 'Meeting_HKGAI_{date}',
    loading_meetings: 'Loading meeting list...',
    generating_summary: 'Generating summary, please wait...',
    loading_summary: 'Loading meeting summary...',
    meeting_summary_saved: 'Meeting summary saved',
    meeting_name_saved: 'Meeting name saved',
    meeting_transcript_saved: 'Meeting transcript saved',
    sidebar_my_meetings: 'My Meetings',
    sidebar_my_favorites: 'My Favorites',
    sidebar_my_shares: 'My Articles',
    sidebar_recycle_bin: 'Recycle Bin',
    sidebar_hot_words: 'My Hot Words',
    sidebar_meeting_assistant: 'Meeting Assistant',
    sidebar_all_chat: 'All Chat',
    sidebar_home: 'Home',
    sidebar_help: 'Help',
    sidebar_account_user: 'User',
    sidebar_account_free_plan: 'Free',
    sidebar_account_pro_plan: 'Pro',
    sidebar_account_advanced_plan: 'Advanced',
    sidebar_account_balance: '{balance} credits',
    sidebar_account_balance_label: '{plan}, {balance} credits remaining',
    sidebar_account_usage: '{remaining}/{allowance} credits',
    sidebar_account_open_menu: 'Open account menu',
    sidebar_account_download_desktop: 'Download Desktop Application',
    sidebar_account_about_plan: 'About plan',
    sidebar_account_quota_label: '{plan}, {remaining} of {allowance} credits remaining',
    home_slogan: 'Speak Freely',
    home_slogan_highlight: 'Speak & Connect',
    meeting_summary: 'Meeting Summary',
    meeting_audio: 'Meeting Audio/Video',
    layout_head_tutorial: 'Usage Tutorial',
    layout_head_it_support: 'IT Support',
    it_support_time: 'Support hours: Monday to Friday (excluding public holidays): 9:00 AM to 6:00 PM',
    it_support_language: 'Language: English and Putonghua',
    exit_modal_password_expired_content: 'Password Expired, Please Reset Password',
    exit_modal_password_expired_button: 'Reset',
    translate_error: 'Translation failed, please try again',
    translating_to: 'Translating to',
    meeting_no_summary: 'No summary available',
    meeting_refresh_summary: 'Refresh meeting summary',
    meeting_summary_loading: 'Loading meeting summary',
    meeting_transcribe_failed: 'Transcription failed, please click the top right corner to try again',
    meeting_transcribing: 'Transcribing, please wait...',
    meeting_reload_summary_error: 'Failed to refresh meeting summary',
    // 反馈相关
    feedback_title: 'How satisfied are you with HKMeeting?',
    feedback_audio_upload_processing: 'Audio Upload & Processing',
    feedback_audio_to_text_accuracy: 'Audio-to-Text Accuracy',
    feedback_summary_quality: 'Summary Quality',
    feedback_interface_interaction: 'Interface & Interaction',
    feedback_other_issues: 'Other Issues',
    feedback_title_why: 'Why?',
    feedback_input_placeholder: 'Enter the feedback content',
    feedback_input_placeholder_required: 'Please enter feedback content (required)',
    feedback_success: 'Feedback submitted successfully',
    feedback_fail: 'Feedback submission failed',
    feedback_btn_text: 'Feedback',
    // 删除确认相关
    confirm_delete: 'Delete',
    cancel: 'Cancel',
    meeting_delete_error: 'Failed to delete meeting, please try again',
    // 回收站相关
    meeting_move_to_recycle_bin_title: 'Move to Recycle Bin',
    meeting_move_to_recycle_bin_content: 'Are you sure you want to move the meeting "{meetingName}" to the recycle bin?',
    move_to_recycle_bin: 'Move to Recycle Bin',
    meeting_moved_to_recycle_bin: 'Moved to recycle bin',
    meeting_permanent_delete_title: 'Permanent Delete',
    meeting_permanent_delete_content: 'Are you sure you want to permanently delete the meeting "{meetingName}"? This action cannot be undone.',
    permanent_delete: 'Permanent Delete',
    meeting_permanent_delete_success: 'Permanently deleted successfully',
    meeting_restore_title: 'Restore Meeting',
    meeting_restore_content: 'Are you sure you want to restore the meeting "{meetingName}"?',
    restore: 'Restore',
    meeting_restored: 'Meeting restored',
    meeting_restore: 'Restore',
    meeting_permanent_delete: 'Permanent Delete',
    meeting_move_to_trash: 'Meeting moved to recycle bin',
    meeting_restore_success: 'Meeting restored successfully',
    // 回收站批量操作
    recycle_bin_select_all: 'Select All',
    recycle_bin_delete_selected: 'Delete Selected',
    recycle_bin_no_items_selected: 'No items selected',
    recycle_bin_delete_selected_confirm_title: 'Confirm Delete Selected',
    recycle_bin_delete_selected_confirm_content_one: 'Are you sure you want to permanently delete the selected {count} item? This action cannot be undone.',
    recycle_bin_delete_selected_confirm_content: 'Are you sure you want to permanently delete the selected {count} items? This action cannot be undone.',
    recycle_bin_delete_selected_success: 'Selected items deleted successfully',
    // 收藏相关
    meeting_favorite: 'Add to Favorites',
    meeting_unfavorite: 'Remove from Favorites',
    meeting_favorited: 'Added to favorites',
    meeting_unfavorited: 'Removed from favorites',
    // 功能卡片
    card_badge_record: 'Meeting Recording Transcription',
    card_title_record: 'Start Recording',
    card_desc_record_line1: 'Record during meetings, summarise after',
    card_desc_record_line2: 'Accurately distinguish speakers, well-structured and easy to read',
    card_badge_upload: 'Audio/Video Processing',
    card_title_upload: 'Start Uploading',
    card_desc_upload_line1: 'Transcribe text and summarise',
    card_desc_upload_line2: 'Precise, rapid and clear',
    card_badge_transcribe: 'Transcribe & Translate',
    card_title_transcribe: 'Live Transcription',
    card_desc_transcribe_line1: 'Live transcription, and translation',
    card_desc_transcribe_line2: 'Auto-detects Cantonese, Mandarin, and English',
    // 跨会议总结页面
    cross_summary_title: 'Cross-Meeting Summary',
    cross_summary_description: 'Select multiple meetings to generate comprehensive articles',
    cross_summary_generate: 'Start Generation',
    cross_summary_generating: 'Generating...',
    cross_summary_select_all: 'Select All',
    cross_summary_select_warning: 'Please select at least one meeting',
    cross_summary_selected: 'Selected {count} meetings',
    cross_summary_generate_success: 'Cross-meeting summary generated successfully',
    cross_summary_generate_error: 'Failed to generate cross-meeting summary',
    cross_summary_no_meetings: 'No available meetings',
    // 生成配置对话框
    cross_summary_config_title: 'Configure Cross-Meeting Summary',
    cross_summary_confirm_generate: 'Confirm Generate',
    cross_summary_title_label: 'Article Title',
    cross_summary_title_placeholder: 'Please enter the title of the generated article',
    cross_summary_title_required: 'Please enter article title',
    cross_summary_title_max_length: 'Title cannot exceed 100 characters',
    cross_summary_type_label: 'Meeting Type',
    cross_summary_type_placeholder: 'Please select meeting type',
    cross_summary_type_required: 'Please select meeting type',
    cross_summary_selected_meetings: 'Selected Meetings',
    // 文章编辑器相关
    enter_title: 'Please enter title',
    untitled_article: 'Untitled Article',
    last_saved: 'Last saved',
    copy: 'Copy',
    edit: 'Edit',
    delete: 'Delete',
    regenerate: 'Regenerate',
    download: 'Download',
    save: 'Save',
    save_success: 'Saved successfully',
    save_error: 'Save failed',
    copy_success: 'Copied successfully',
    copy_error: 'Copy failed',
    download_success: 'Downloaded successfully',
    download_error: 'Download failed',
    no_content_to_download: 'No content to download',
    generating_article: 'Generating article',
    confirm_regenerate: 'Confirm Regenerate',
    confirm_regenerate_content: 'Regenerating will overwrite current content, continue?',
    unsaved_changes: 'Unsaved Changes',
    unsaved_changes_content: 'You have unsaved changes, are you sure you want to leave?',
    original_language: 'EN',
    source_meetings_title: 'Based on the following meetings',
    meeting_card_tooltip: 'Click to view meeting',
    // 长文相关
    article_delete_confirm_title: 'Confirm Delete',
    article_delete_confirm_content: 'Are you sure you want to delete this article? It can be restored from the recycle bin.',
    article_permanent_delete_title: 'Confirm Permanent Delete',
    article_permanent_delete_content: 'The article cannot be recovered after permanent deletion. Are you sure you want to delete this article?',
    article_restore_tooltip: 'Restore',
    article_permanent_delete_tooltip: 'Permanent Delete',
    no_saved_articles: 'No saved articles',
    no_favorites: 'No favorites yet',
    // 录音相关
    meeting_create_title: 'Add audio/video files to generate transcript',
    meeting_create_description: 'Depending on the size of the audio/video file, processing and transcription will take approximately 10-15 mins. (1 hour audio/video)',
    meeting_upload_description: 'Click or drag WAV, MP3, M4A, MP4 files here to upload',
    meeting_upload_limit_msg: 'Audio file size cannot exceed 600MB, video file size cannot exceed 500MB',
    meeting_name_limit_length: 'Cannot exceed 80 characters',
    meeting_time_future_error: 'The meeting time cannot be in the future',
    meeting_file_upload_error: 'File upload failed, please try again',
    meeting_name_required: 'Please enter meeting title',
    meeting_upload_file_required: 'Please record audio or upload file first',
    meeting_recording_required: 'Please record audio first',
    meeting_upload_file_required_recording: 'Audio is recording, please complete the recording before submitting',
    meeting_audio_size_limit: 'Audio file size cannot exceed 600MB',
    meeting_video_size_limit: 'Video file size cannot exceed 500MB',
    meeting_obs_token_error: 'Get upload credentials failed, please try again',
    login_status_expired_relogin: 'Session has expired, please log in again.',
    meeting_modal_confirm_record_finish_content: 'Confirm to complete this meeting recording?',
    meeting_back_warn_on_recording: 'Exiting will end the meeting and all content will not be saved.',
    // 添加麦克风权限相关文本
    meeting_modal_error_permission_denied_title: 'Microphone Permission Denied',
    meeting_modal_error_permission_denied_content: 'Please allow microphone access in your browser settings, then try again.',
    meeting_modal_error_record_open_failed: 'Failed to open recording, please check microphone permissions and try again',
    meeting_modal_error_retry: 'Retry',
    // Transcribe related
    transcribe_translate_button_label: 'Translate',
    transcribe_translate_auto_switch: 'Auto Switch',
    transcribe_speaker_label: 'Speaker',
    transcribe_empty_placeholder: 'Live transcription will appear here',
    meeting_translation_fetch_error: 'Failed to fetch translation. Please try again.',
    transcribe_connection_lost: 'Live transcription was disconnected. Local audio is still recording.',
    transcribe_connection_retry: 'Retry transcription',
    transcribe_connection_retry_failed: 'Unable to restart transcription. Please check your connection and try again.',
    transcribe_download_audio: 'Download audio',
    transcribe_download_end_title: 'Download audio and end meeting?',
    transcribe_download_end_content: 'Downloading will stop the recording and end this meeting. The audio will only be saved to this device.',
    transcribe_download_end_confirm: 'Download and end',
    transcribe_audio_download_error: 'Unable to download the recorded audio.',
    transcribe_recording_preparing: 'Preparing recording...',
    transcribe_recording_preparing_description: 'Finalizing the local WAV file. Please keep this page open.',
    transcribe_recording_uploading: 'Uploading recording...',
    transcribe_recording_uploading_description: 'Your recording is being uploaded. Please keep this page open.',
    transcribe_meeting_creating: 'Creating meeting...',
    transcribe_meeting_creating_description: 'The upload is complete. Your meeting details are being saved.',
    transcribe_recording_upload_failed: 'Recording upload failed',
    transcribe_recording_upload_failed_description: 'Your recording is still available in this browser. Retry the upload or download a backup.',
    transcribe_meeting_create_failed: 'Meeting creation failed',
    transcribe_meeting_create_failed_description: 'The recording was uploaded successfully. Retry creating the meeting without uploading it again.',
    transcribe_retry_upload: 'Retry upload',
    transcribe_retry_create: 'Retry creating meeting',
    transcribe_finalizing_leave_content: 'Recording processing is not complete. Leaving now may lose the local recording; download a backup before leaving.',
    // Meeting Detail
    meeting_detail_tab_transcript: 'Transcript',
    meeting_detail_tab_summary_editor: 'Edit & QA',
    meeting_formal_language: 'Formal Language',
    meeting_detail_chat_input_placeholder: 'Please enter editing & QA requirements',
    meeting_detail_chat_input_hint: 'Shift+Enter for line break',
    meeting_detail_chat_editing: 'Intelligent editing...',
    meeting_detail_chat_text_copy: 'Copy',
    meeting_detail_chat_text_copied: 'Copied',
    meeting_detail_chat_text_edit: 'Edit',
    meeting_detail_chat_upload_file: 'Upload File (txt, doc, docx, pdf)',
    meeting_detail_chat_uploading: 'Uploading...',
    meeting_detail_chat_upload_error: 'Upload failed, click to retry',
    meeting_detail_chat_max_file_count_error: 'Maximum 1 file allowed',
    meeting_detail_chat_input_required_with_file: 'Please enter your editing requirements',
    meeting_detail_chat_stop_using_file: 'Stop using this file for Q&A',
    meeting_detail_chat_mode_agent: 'Agent',
    meeting_detail_chat_mode_ask: 'Ask',
    meeting_detail_chat_stop_generating: 'Stop generating',
    meeting_detail_chat_stopping: 'Stopping',
    meeting_detail_chat_generation_stopped: 'Generation stopped',
    meeting_detail_chat_stop_failed: 'Failed to stop',
    meeting_detail_chat_retry_stop: 'Retry stopping',
    meeting_detail_chat_commit_failed: 'Summary save failed; changes reverted',
    meeting_tooltip_send_mail: 'Send Email',
    meeting_placeholder_text: 'Start typing...',
    meeting_translate_success: 'Successfully translated into {langName}',
    translate_lang_en: 'English',
    translate_lang_zh_cn: 'Simplified Chinese',
    translate_lang_zh_hk: 'Traditional Chinese',
    meeting_total_count: 'Total words',
    // Send email modal
    send_email_modal_title: 'Send Meeting Minutes',
    send_email_recipients_label: 'Recipients',
    send_email_sumarry_label: 'Meeting Minutes',
    send_email_recipients_placeholder: 'Please enter recipient email addresses. Separate multiple recipients with a comma, semicolon, or enter',
    send_email_recipients_hint: 'Max 50 recipients. Separate multiple emails with commas, semicolons, or enter',
    send_email_send_button: 'Send',
    send_email_max_recipients_toast: 'Max 50 recipients at a time.',
    send_email_daily_limit_toast: 'Daily limit (300 emails) reached.',
    send_email_success_toast: 'Meeting minutes sent successfully to recipients.',
    send_email_failed_toast: 'Email delivery failed. Please check the email format or try again later.',
    // Membership credits
    membership_credits_modal_title: 'My Credits Usage',
    membership_credits_modal_subtitle: 'What you have left this cycle, and where it went.',
    membership_credits_close: 'Close',
    membership_credits_overview_label: 'Credit balance overview',
    membership_credits_left: 'credits left',
    membership_credits_plan_badge: '{plan} · {allowance} / month',
    membership_credits_audio_equivalent: '≈ {time} of audio · 1 credit records or transcribes 1 minute',
    membership_credits_resets_in: 'Resets in {days} days',
    membership_credits_expiry: 'Membership valid until {date}',
    membership_credits_used_label: '{used} of {allowance} credits used',
    membership_credits_used_percentage: '{percent}% Used',
    membership_credits_breakdown_title: 'Where your credits went',
    membership_credits_rate: '1 credit = 1 minute',
    membership_credits_cycle_used: 'This cycle · {used} used',
    membership_credits_cycle_used_with_period: 'This cycle ({start} – {end}) · {used} used',
    membership_credits_service: 'Service',
    membership_credits_time: 'Time',
    membership_credits_credits: 'Credits',
    membership_credits_service_file: 'File transcription',
    membership_credits_service_recording: 'Recording',
    membership_credits_service_live: 'Live translation',
    membership_credits_note: 'Per-meeting history is available in Usage detail.',
    membership_credits_manage_subscription: 'Manage subscription',
    membership_credits_usage_details: 'Credits Usage Details',
    membership_credits_time_hours_minutes: '{hours} h {minutes} m',
    membership_credits_time_minutes: '{minutes} m',
    membership_credits_plan_badge_live: '{plan} · {allowance} {period}',
    membership_credits_per_cycle: 'per 31-day cycle',
    membership_credits_per_month: 'per month',
    membership_credits_balance_hint: 'Available across all active credit batches',
    membership_credits_next_cycle: 'Next grant/reset',
    membership_credits_source_free: 'Free credits',
    membership_credits_source_subscription: 'Subscription credits',
    membership_credits_source_purchase: 'Purchased credits',
    membership_credits_source_other: 'Credits',
    membership_credits_rules_title: 'Points Usage Rules',
    membership_credits_rule_file: 'File transcription: 1 credit / 1 min',
    membership_credits_rule_recording: 'Audio transcription: 1 credit / 1 min',
    membership_credits_rule_live: 'Real-time interpretation: 1 credit / 1 min',
    membership_credits_expiring_title: 'Upcoming expirations',
    membership_credits_expiring_hint: 'Up to 10 active batches',
    membership_credits_no_expirations: 'No active credit batches are due to expire.',
    membership_credits_load_error: 'Unable to load membership and credit details.',
    membership_credits_retry: 'Retry',
    membership_credits_transactions_title: 'Credits Usage Details',
    membership_credits_transactions_subtitle: 'A detailed record of grants, usage, expirations, and adjustments.',
    membership_credits_transactions_error: 'Unable to load credit transactions.',
    membership_credits_transactions_empty: 'No credit transactions yet.',
    membership_credits_transaction_time: 'Time',
    membership_credits_transaction_detail: 'Detail',
    membership_credits_transaction_source: 'Source',
    membership_credits_transaction_type: 'Type',
    membership_credits_transaction_change: 'Change',
    membership_credits_transaction_balance: 'Balance',
    membership_credits_transaction_grant: 'Granted',
    membership_credits_transaction_consume: 'Used',
    membership_credits_transaction_expire: 'Expired',
    membership_credits_transaction_adjust: 'Adjusted',
    credits_check_failed_title: 'Unable to check credits',
    credits_check_failed_content: 'Your latest credit balance could not be verified. Please try again.',
    credits_insufficient_title: 'Insufficient credits',
    credits_insufficient_empty: 'Your current credit balance is insufficient. Please get more credits and try again.',
    credits_insufficient_required:
      'This submission requires approximately {required} credits. You currently have {balance} credits available. Please get more credits and try again.',
    credits_live_transcription_low_title: 'Credits running low',
    credits_live_transcription_low_content: 'You have “{balance}” credits remaining, for an estimated transcription time of “{duration}”.',
    credits_live_transcription_ended: 'Your remaining credit balance is “{balance}”. The meeting has ended automatically.',
    credits_dialog_ok: 'Got it',
    credits_estimate_transcription: 'Approximately {credits} credits will be used for transcription.',
    credits_recording_available_time: 'Available recording time: {time}',
    meeting_media_duration_error: 'Unable to read the media duration. Please choose another file.',
    // 注册相关
    login_download_slogan: 'One client for all your meetings, online & offline',
    login_download_windows_button: 'Windows Download',
    login_download_mac_button: 'MacOS Download',
    login_form_reg_button: 'Sign up',
    reg_password_required: 'Password is required',
    reg_password_format_error: '8-15 character password containing at least 1 uppercase and lowercase letter, number, and symbol.',
    reg_confirm_password_mismatch: 'The passwords do not match. Please try again.',
    reg_email_required: 'Please enter your email',
    reg_email_format_error: 'Invalid email address. Please check.',
    reg_email_domain_error: 'Only emails ending in ust.hk or connect.ust.hk are allowed.',
    reg_email_already_registered: 'This email is already registered. Please login.',
    reg_verification_code_sent: "Verification code sent successfully! If you don't receive it, please check your junk mail or try again later.",
    reg_verification_code_too_frequent: 'Verification code sent too frequently. Please try again later.',
    reg_verification_code_invalid: 'Invalid or expired verification code.',
    reg_network_error: 'Network error, please try again later.',
    reg_slogan: 'Sign Up',
    reg_username_required: 'Please enter a name',
    reg_username_max_length: 'Name cannot exceed 40 characters',
    reg_username_placeholder: 'Please enter your name or nickname',
    reg_email_placeholder: 'HKUST email (@connect.ust.hk / @ust.hk) only',
    reg_password_placeholder: '8-15 characters (inc. uppercase, lowercase, numbers & symbols)',
    reg_confirm_password_placeholder: 'Please re-enter password to confirm',
    reg_verification_code_placeholder: 'Enter 6-digit email verification code',
    reg_send_code_button: 'Send',
    reg_submit_button: 'Submit Registration',
    reg_success: 'Registration successful',
    reg_failed: 'Registration failed',
    reg_domain_restriction_notice: 'Registration is currently limited to @connect.ust.hk or @ust.hk email addresses. Stay tuned for more domain support',
    // 邀请注册相关
    invite_code_placeholder: 'Enter 6-character invitation code',
    invite_code_required: 'Please enter the invitation code',
    invite_code_format_error: 'Invitation code must be 6 alphanumeric characters',
    invite_code_invalid: 'Invalid invitation code. Please check and try again',
    invite_code_exhausted: 'This invitation code has reached its usage limit',
    invite_notice: 'Scan the QR code or use the dedicated URL to access the invitation page',
    invite_email_placeholder: 'Please enter your email',
    // 找回密码相关
    pwd_find_slogan: 'Recover Password',
    pwd_find_email_placeholder: 'Please enter your registered email',
    pwd_find_email_required: 'Please enter your email',
    pwd_find_email_format_error: 'Invalid email address. Please check.',
    pwd_find_password_placeholder: '8-15 characters (inc. uppercase, lowercase, numbers & symbols)',
    pwd_find_password_required: 'Password is required',
    pwd_find_password_format_error: '8-15 character password containing at least 1 uppercase and lowercase letter, number, and symbol.',
    pwd_find_confirm_password_placeholder: 'Please re-enter password to confirm',
    pwd_find_confirm_password_mismatch: 'The passwords do not match. Please try again.',
    pwd_find_verification_code_placeholder: 'Enter 6-digit email verification code',
    pwd_find_verification_code_invalid: 'Invalid or expired verification code.',
    pwd_find_send_code_button: 'Send',
    pwd_find_submit_button: 'Confirm',
    pwd_find_success: 'Password reset successful',
    pwd_find_failed: 'Password reset failed',
    pwd_find_verification_code_sent: "Password recovery verification code sent successfully! If you don't receive it, please check your junk mail or try again later",
    pwd_reset_verification_code_sent: "Password reset verification code sent successfully! If you don't receive it, please check your junk mail or try again later",
    pwd_find_verification_code_too_frequent: 'Verification code sent too frequently. Please try again later.',
    pwd_find_network_error: 'Network error, please try again later.',
    pwd_find_email_not_found: 'Email not found. Please verify the address or register.',
    pwd_find_password_duplication: 'New password cannot be the same as the old one',
    ...(language_h5['en-US'] || {}),
    // Meeting Assistant
    assistant_landing_title: 'HKMeeting Assistant',
    assistant_landing_subtitle: 'AI-Powered Meeting Intelligence, Reimagining Office Collaboration Efficiency',
    assistant_input_placeholder: 'Enter your meeting processing requirements...',
    assistant_thinking: 'Thinking...',
    assistant_error: 'Failed to get response, please try again',
    assistant_delete_confirm_title: 'Delete Chat?',
    assistant_delete_confirm_content: 'This chat will be permanently deleted and cannot be recovered',
    assistant_delete_success: 'Chat deleted successfully',
    assistant_history_title: 'Chat History',
    assistant_loading_history: 'Loading chat history...',
    assistant_no_history: 'No chat history yet',
    assistant_shift_enter_hint: 'Shift+Enter for line break',
    // Hot Words
    hot_words_title: 'Hot Words',
    hot_words_subtitle: 'Exclusive vocabulary, prioritized for recognition to improve accuracy in identification and translation',
    hot_words_guide_title: 'User Guide',
    hot_words_guide_desc: 'Review rules first before adding hot words for the best recognition.',
    hot_words_rule_1_title: 'Input Format Rule',
    hot_words_rule_1_desc: 'In the right input box, enter one hot word per line only.',
    hot_words_rule_2_title: 'Hot Word Limit',
    hot_words_rule_2_desc: 'Maximum 300 hot words; excess entries will be ignored.',
    hot_words_rule_3_title: 'Length Restriction',
    hot_words_rule_3_desc: 'Each hot word must not exceed 30 Chinese characters or 30 English words.',
    hot_words_rule_4_title: 'Character Specification',
    hot_words_rule_4_desc: "Only text, spaces, and the following three symbols are allowed: hyphen (-), ampersand (&), apostrophe ('). No other punctuation marks are supported.",
    hot_words_rule_5_title: 'Number & Symbol Handling',
    hot_words_rule_5_desc:
      "Replace Arabic numerals or special symbols in hot words with English letters or words, and keep the text in UPPERCASE (e.g., change 'Greater Bay Area 2026' to 'GREATER BAY AREA TWENTY TWENTY SIX').",
    hot_words_rule_6_title: 'Avoid Invalid Vocabulary',
    hot_words_rule_6_desc:
      'Prioritize brand names, proper nouns, personal names, and key terms for better recognition; avoid single characters or meaningless common words to maintain accuracy.',
    hot_words_custom_label: 'Custom Hot Words',
    hot_words_input_placeholder: 'Hot Word 1\nHot Word 2',
    hot_words_undo_changes: 'Undo Changes',
    hot_words_save: 'Save',
    hot_words_save_success: 'Saved Successfully',
    hot_words_error_exists: 'The hotword already exists and cannot be added repeatedly',
    hot_words_error_invalid_chars: 'The hotword contains non-compliant characters',
    hot_words_error_too_long: 'The character length of a single hotword exceeds the limit',
    hot_words_error_too_many: 'The total number of hotwords has reached the upper limit',
    hot_words_save_error: 'Failed to save hot words',
    meeting_download_starting: 'Downloading... 0%',
    meeting_download_progress: 'Downloading {percent}%',
    meeting_download_complete: 'Download complete 100%',
    meeting_download_failed: 'Download failed',
    term_of_use_title: 'Terms of Use',
    term_of_use_content:
      'The application is provided for informational purposes only and should not be relied upon for making legally binding decisions, with users advised to verify critical information through official channels and adhere to all relevant data privacy and ethical guidelines. The application expressly disclaims any responsibility for inaccuracies or misapplication of the information provided.',
  },
  'zh-CN': {
    ...(language['zh-CN'] || {}),
    meeting_type_general: '一般会议',
    meeting_type_social_media: '社交媒体',
    meeting_type_government_gazette: '政府公报',
    upload_audio: '上传音/视频',
    record_audio: '录制音频',
    transcribe_audio: '实时传译',
    start: '开始',
    meeting_name_placeholder: '会议_HKGAI_{date}',
    loading_meetings: '正在加载会议列表...',
    generating_summary: '正在生成摘要，请稍候...',
    loading_summary: '正在加载会议总结...',
    meeting_summary_saved: '会议纪要已保存',
    meeting_name_saved: '会议名称已保存',
    meeting_transcript_saved: '会议转录已保存',
    sidebar_my_meetings: '我的会议',
    sidebar_my_favorites: '我的收藏',
    sidebar_my_shares: '我的长文',
    sidebar_recycle_bin: '回收站',
    sidebar_hot_words: '我的热词',
    sidebar_meeting_assistant: '会议助手',
    sidebar_all_chat: '查看全部',
    sidebar_home: '首页',
    sidebar_help: '帮助',
    sidebar_account_user: '用户',
    sidebar_account_free_plan: '免费版',
    sidebar_account_pro_plan: '专业版',
    sidebar_account_advanced_plan: '高级版',
    sidebar_account_balance: '{balance} 积分',
    sidebar_account_balance_label: '{plan}，剩余 {balance} 积分',
    sidebar_account_usage: '{remaining}/{allowance} 积分',
    sidebar_account_open_menu: '打开账户菜单',
    sidebar_account_download_desktop: '下载桌面应用',
    sidebar_account_about_plan: '关于计划',
    sidebar_account_quota_label: '{plan}，剩余 {remaining}/{allowance} 积分',
    home_slogan: '多语随心',
    home_slogan_highlight: '沟通无界',
    meeting_summary: '会议总结',
    meeting_audio: '会议音/视频',
    layout_head_tutorial: '使用指引',
    layout_head_it_support: '技术支持',
    it_support_time: '支持时间：周一至周五（除公共假期）：上午9:00至下午6:00',
    it_support_language: '支持语言：英语及普通话',
    exit_modal_password_expired_content: '密码过期，请重置密码',
    exit_modal_password_expired_button: '重置',
    translate_error: '翻译失败，请重试',
    translating_to: '正在翻译为',
    meeting_no_summary: '暂无会议总结',
    meeting_refresh_summary: '刷新会议总结',
    meeting_summary_loading: '正在加载会议总结',
    meeting_transcribe_failed: '转写失败，请点击右上角重试',
    meeting_transcribing: '正在转写中，请稍候...',
    meeting_reload_summary_error: '会议总结刷新失败',
    // 反馈相关
    feedback_title: '请为我们的产品满意度打分',
    feedback_audio_upload_processing: '上传与处理音频',
    feedback_audio_to_text_accuracy: '音频转文字准确性',
    feedback_summary_quality: '会议纪要生成质量',
    feedback_interface_interaction: '界面与交互',
    feedback_other_issues: '其它问题',
    feedback_title_why: '为什么?',
    feedback_input_placeholder: '请在此输入反馈内容',
    feedback_input_placeholder_required: '请在此输入反馈内容（必填）',
    feedback_success: '反馈成功',
    feedback_fail: '反馈失败',
    feedback_btn_text: '反馈',
    // 删除确认相关
    confirm_delete: '删除',
    cancel: '取消',
    meeting_delete_error: '删除失败，请重试',
    // 回收站相关
    meeting_move_to_recycle_bin_title: '移动到回收站',
    meeting_move_to_recycle_bin_content: '确定要将会议 "{meetingName}" 移动到回收站吗？',
    move_to_recycle_bin: '移动到回收站',
    meeting_moved_to_recycle_bin: '已移动到回收站',
    meeting_permanent_delete_title: '永久删除',
    meeting_permanent_delete_content: '确定要永久删除会议 "{meetingName}" 吗？此操作不可撤销。',
    permanent_delete: '永久删除',
    meeting_permanent_delete_success: '永久删除成功',
    meeting_restore_title: '恢复会议',
    meeting_restore_content: '确定要恢复会议 "{meetingName}" 吗？',
    restore: '恢复',
    meeting_restored: '会议已恢复',
    meeting_restore: '恢复',
    meeting_permanent_delete: '永久删除',
    meeting_move_to_trash: '会议已移至回收站',
    meeting_restore_success: '会议恢复成功',
    // 回收站批量操作
    recycle_bin_select_all: '全选',
    recycle_bin_delete_selected: '删除所选',
    recycle_bin_no_items_selected: '未选择任何项目',
    recycle_bin_delete_selected_confirm_title: '确认删除所选',
    recycle_bin_delete_selected_confirm_content_one: '确定要永久删除所选的 {count} 项吗？此操作不可撤销。',
    recycle_bin_delete_selected_confirm_content: '确定要永久删除所选的 {count} 项吗？此操作不可撤销。',
    recycle_bin_delete_selected_success: '所选项目删除成功',
    // 收藏相关
    meeting_favorite: '收藏',
    meeting_unfavorite: '取消收藏',
    meeting_favorited: '已收藏',
    meeting_unfavorited: '已取消收藏',
    // 功能卡片
    card_badge_record: '会议录音整理',
    card_title_record: '开始录制',
    card_desc_record_line1: '会中录制，会后纪要',
    card_desc_record_line2: '多人对话精准区分，语篇规整一目了然',
    card_badge_upload: '音频/视频处理',
    card_title_upload: '开始上传',
    card_desc_upload_line1: '提取文字，归纳总结',
    card_desc_upload_line2: '精准识别极速出稿，智能纪要条理清晰',
    card_badge_transcribe: '实时转录传译',
    card_title_transcribe: '开始同传',
    card_desc_transcribe_line1: '边录边转，同步翻译',
    card_desc_transcribe_line2: '粤普英自动识别，多端同步即时查阅',
    // 跨会议总结页面
    cross_summary_title: '跨会议总结',
    cross_summary_description: '选择多个会议，生成综合性长篇稿件',
    cross_summary_generate: '开始生成',
    cross_summary_generating: '生成中...',
    cross_summary_select_all: '全选',
    cross_summary_select_warning: '请至少选择一个会议',
    cross_summary_selected: '已选择 {count} 个会议',
    cross_summary_generate_success: '跨会议总结生成成功',
    cross_summary_generate_error: '生成跨会议总结失败',
    cross_summary_no_meetings: '暂无可用的会议',
    // 生成配置对话框
    cross_summary_config_title: '配置跨会议总结',
    cross_summary_confirm_generate: '确认生成',
    cross_summary_title_label: '文章标题',
    cross_summary_title_placeholder: '请输入生成文章的标题',
    cross_summary_title_required: '请输入文章标题',
    cross_summary_title_max_length: '标题不能超过100个字符',
    cross_summary_type_label: '会议类型',
    cross_summary_type_placeholder: '请选择会议类型',
    cross_summary_type_required: '请选择会议类型',
    cross_summary_selected_meetings: '已选择的会议',
    // 文章编辑器相关
    enter_title: '请输入标题',
    untitled_article: '无标题文章',
    last_saved: '上次保存',
    copy: '复制',
    edit: '编辑',
    delete: '删除',
    regenerate: '重新生成',
    download: '下载',
    save: '保存',
    save_success: '保存成功',
    save_error: '保存失败',
    copy_success: '复制成功',
    copy_error: '复制失败',
    download_success: '下载成功',
    download_error: '下载失败',
    no_content_to_download: '没有内容可下载',
    generating_article: '正在生成长文',
    confirm_regenerate: '确认重新生成',
    confirm_regenerate_content: '重新生成将覆盖当前内容，确定继续吗？',
    unsaved_changes: '未保存的更改',
    unsaved_changes_content: '您有未保存的更改，确定要离开吗？',
    original_language: '原文',
    source_meetings_title: '基于以下会议生成',
    meeting_card_tooltip: '点击查看会议',
    // 长文相关
    article_delete_confirm_title: '确认删除',
    article_delete_confirm_content: '确定要删除这篇长文吗？删除后可在回收站中恢复。',
    article_permanent_delete_title: '确认永久删除',
    article_permanent_delete_content: '永久删除后无法恢复，确定要删除这篇长文吗？',
    article_restore_tooltip: '恢复',
    article_permanent_delete_tooltip: '永久删除',
    no_saved_articles: '暂无保存的长文',
    no_favorites: '暂无收藏内容',
    // 录音相关
    meeting_create_title: '上传音频 / 视频文件以生成转录文本',
    meeting_create_description: '根据音频 / 视频文件的大小，处理和转录大约需要 10-15 分钟。（1小时音频/视频）',
    meeting_upload_description: '点击或拖拽WAV、MP3、 M4A、MP4文件到此处上传',
    meeting_upload_limit_msg: '音频文件大小不能超过600MB，视频文件大小不能超过500MB',
    meeting_name_limit_length: '不能超过80个字符',
    meeting_time_future_error: '会议时间不能大于当前时间',
    meeting_file_upload_error: '文件上传失败，请重试',
    meeting_name_required: '请输入会议标题',
    meeting_upload_file_required: '请先录制或上传文件',
    meeting_recording_required: '请先录制音频',
    meeting_upload_file_required_recording: '音频录制中，请确认完成录制后再提交',
    meeting_audio_size_limit: '音频文件大小不能超过600MB',
    meeting_video_size_limit: '视频文件大小不能超过500MB',
    meeting_obs_token_error: '获取上传凭证失败，请重试',
    login_status_expired_relogin: '登录态已过期，请重新登录',
    meeting_modal_confirm_record_finish_content: '确认完成本次会议录音?',
    meeting_back_warn_on_recording: '退出将结束本次会议，全部内容无法保存',
    // 添加麦克风权限相关文本
    meeting_modal_error_permission_denied_title: '麦克风权限被拒绝',
    meeting_modal_error_permission_denied_content: '请在浏览器设置中允许访问麦克风，然后重试。',
    meeting_modal_error_record_open_failed: '打开录音失败，请检查麦克风权限并重试',
    meeting_modal_error_retry: '重试',
    // Transcribe related
    transcribe_translate_button_label: '翻译',
    transcribe_translate_auto_switch: '自动切换',
    transcribe_speaker_label: '发言人',
    transcribe_empty_placeholder: '实时转录内容将显示在这里',
    meeting_translation_fetch_error: '获取翻译失败，请重试。',
    transcribe_connection_lost: '实时转录已断开，本地音频仍在录制。',
    transcribe_connection_retry: '重试转录',
    transcribe_connection_retry_failed: '无法重新启动转录，请检查网络后重试。',
    transcribe_download_audio: '下载音频',
    transcribe_download_end_title: '下载音频并结束会议？',
    transcribe_download_end_content: '下载将停止录音并结束本次会议，音频只会保存到当前设备。',
    transcribe_download_end_confirm: '下载并结束',
    transcribe_audio_download_error: '无法下载已录制的音频。',
    transcribe_recording_preparing: '正在准备录音……',
    transcribe_recording_preparing_description: '正在生成本地 WAV 文件，请保持此页面打开。',
    transcribe_recording_uploading: '正在上传录音……',
    transcribe_recording_uploading_description: '录音正在上传，请保持此页面打开。',
    transcribe_meeting_creating: '正在创建会议……',
    transcribe_meeting_creating_description: '录音已上传，正在保存会议资料。',
    transcribe_recording_upload_failed: '录音上传失败',
    transcribe_recording_upload_failed_description: '录音仍保留在此浏览器中。您可以重试上传或下载备份。',
    transcribe_meeting_create_failed: '会议创建失败',
    transcribe_meeting_create_failed_description: '录音已成功上传。您可以重试创建会议，无需再次上传。',
    transcribe_retry_upload: '重试上传',
    transcribe_retry_create: '重试创建会议',
    transcribe_finalizing_leave_content: '录音尚未处理完成。现在离开可能会丢失本地录音，请先下载备份。',
    // Meeting Detail
    meeting_detail_tab_transcript: '会议转录',
    meeting_detail_tab_summary_editor: '编辑&问答',
    meeting_formal_language: '书面语',
    meeting_total_count: '总字数',
    meeting_detail_chat_input_placeholder: '请输入编辑 & 问答需求',
    meeting_detail_chat_input_hint: 'Shift+Enter 换行',
    meeting_detail_chat_editing: '智能编辑中...',
    meeting_detail_chat_text_copy: '复制',
    meeting_detail_chat_text_copied: '已复制',
    meeting_detail_chat_text_edit: '编辑',
    meeting_detail_chat_upload_file: '上传文件（txt、doc、docx、pdf）',
    meeting_detail_chat_uploading: '上传中...',
    meeting_detail_chat_upload_error: '上传失败，点击重试',
    meeting_detail_chat_max_file_count_error: '最多允许上传1个文件',
    meeting_detail_chat_input_required_with_file: '请输您的编辑需求',
    meeting_detail_chat_stop_using_file: '不再围绕这个文件问答',
    meeting_detail_chat_mode_agent: '智能体模式',
    meeting_detail_chat_mode_ask: '问答模式',
    meeting_detail_chat_stop_generating: '停止生成',
    meeting_detail_chat_stopping: '正在停止',
    meeting_detail_chat_generation_stopped: '已停止生成',
    meeting_detail_chat_stop_failed: '停止失败',
    meeting_detail_chat_retry_stop: '重试停止',
    meeting_detail_chat_commit_failed: '会议纪要保存失败，修改已还原',
    meeting_tooltip_send_mail: '发送邮件',
    meeting_placeholder_text: '开始输入...',
    meeting_translate_success: '翻译为{langName}成功',
    translate_lang_en: '英文',
    translate_lang_zh_cn: '简体中文',
    translate_lang_zh_hk: '繁体中文',
    // 发送邮件弹窗
    send_email_modal_title: '发送会议纪要',
    send_email_recipients_label: '收件人',
    send_email_sumarry_label: '会议纪要',
    send_email_recipients_placeholder: '请输入邮箱地址，多个邮箱用英文逗号或英文分号或回车分隔',
    send_email_recipients_hint: '单次最多添加 50 个收件人，多个邮箱请用英文逗号或英文分号或回车分隔',
    send_email_send_button: '发送',
    send_email_max_recipients_toast: '单次最多添加 50 个收件人',
    send_email_daily_limit_toast: '今日发送量达300封上限',
    send_email_success_toast: '会议纪要已成功发送至收件人',
    send_email_failed_toast: '邮件发送失败，请检查邮件格式或稍后重试',
    // 会员积分
    membership_credits_modal_title: '我的积分用量',
    membership_credits_modal_subtitle: '查看本周期剩余积分及使用情况。',
    membership_credits_close: '关闭',
    membership_credits_overview_label: '积分余额概览',
    membership_credits_left: '剩余积分',
    membership_credits_plan_badge: '{plan} · 每月 {allowance}',
    membership_credits_audio_equivalent: '≈ {time} 音频 · 录音或转录 1 分钟消耗 1 积分',
    membership_credits_resets_in: '将在 {days} 天后重置',
    membership_credits_expiry: '会员有效期至 {date}',
    membership_credits_used_label: '已使用 {used}/{allowance} 积分',
    membership_credits_used_percentage: '{percent}% 已用',
    membership_credits_breakdown_title: '积分使用去向',
    membership_credits_rate: '1 积分 = 1 分钟',
    membership_credits_cycle_used: '本周期 · 已使用 {used}',
    membership_credits_cycle_used_with_period: '本周期（{start} – {end}）· 已使用 {used}',
    membership_credits_service: '服务',
    membership_credits_time: '时长',
    membership_credits_credits: '积分',
    membership_credits_service_file: '文件转录',
    membership_credits_service_recording: '录音',
    membership_credits_service_live: '实时传译',
    membership_credits_note: '每场会议的记录可在“使用详情”中查看。',
    membership_credits_manage_subscription: '管理订阅',
    membership_credits_usage_details: '积分使用详情',
    membership_credits_time_hours_minutes: '{hours} 小时 {minutes} 分钟',
    membership_credits_time_minutes: '{minutes} 分钟',
    membership_credits_plan_badge_live: '{plan} · {allowance} {period}',
    membership_credits_per_cycle: '每 31 天',
    membership_credits_per_month: '每月',
    membership_credits_balance_hint: '所有有效积分批次的可用总额',
    membership_credits_next_cycle: '下次发放/重置',
    membership_credits_source_free: '免费积分',
    membership_credits_source_subscription: '订阅积分',
    membership_credits_source_purchase: '购买积分',
    membership_credits_source_other: '积分',
    membership_credits_rules_title: '积分使用规则',
    membership_credits_rule_file: '文件转录：1 积分 / 1 分钟',
    membership_credits_rule_recording: '录音转录：1 积分 / 1 分钟',
    membership_credits_rule_live: '实时传译：1 积分 / 1 分钟',
    membership_credits_expiring_title: '即将到期的积分',
    membership_credits_expiring_hint: '最多显示 10 个有效批次',
    membership_credits_no_expirations: '暂无即将到期的有效积分批次。',
    membership_credits_load_error: '无法加载会员及积分详情。',
    membership_credits_retry: '重试',
    membership_credits_transactions_title: '积分使用详情',
    membership_credits_transactions_subtitle: '查看积分发放、使用、过期及调整记录。',
    membership_credits_transactions_error: '无法加载积分流水。',
    membership_credits_transactions_empty: '暂无积分流水。',
    membership_credits_transaction_time: '时间',
    membership_credits_transaction_detail: '详情',
    membership_credits_transaction_source: '来源',
    membership_credits_transaction_type: '类型',
    membership_credits_transaction_change: '变动',
    membership_credits_transaction_balance: '变动后余额',
    membership_credits_transaction_grant: '发放',
    membership_credits_transaction_consume: '使用',
    membership_credits_transaction_expire: '过期',
    membership_credits_transaction_adjust: '调整',
    credits_check_failed_title: '无法查询积分',
    credits_check_failed_content: '暂时无法确认您的最新积分余额，请重试。',
    credits_insufficient_title: '积分不足',
    credits_insufficient_empty: '当前积分余额不足，请获取更多积分后再次尝试。',
    credits_insufficient_required: '本次提交预计需消耗 {required} 积分，您当前可用 {balance} 积分，请获取更多积分后再次尝试。',
    credits_live_transcription_low_title: '积分即将用尽',
    credits_live_transcription_low_content: '当前剩余积分为「{balance}」，预计可使用转录时长为「{duration}」。',
    credits_live_transcription_ended: '当前剩余积分为「{balance}」，会议已自动结束。',
    credits_dialog_ok: '知道了',
    credits_estimate_transcription: '本次转录预计将使用 {credits} 积分。',
    credits_recording_available_time: '可用录音时长：{time}',
    meeting_media_duration_error: '无法读取音频或视频时长，请选择其他文件。',
    // 注册相关
    login_download_slogan: '线上线下会议，就用客户端',
    login_download_windows_button: 'Windows 下载',
    login_download_mac_button: 'MacOS 下载',
    login_form_reg_button: '注册账号',
    reg_password_required: '请输入密码',
    reg_password_format_error: '请输入8-15位含大写、小写字母、数字和特殊符号的密码',
    reg_confirm_password_mismatch: '密码不一致，请重试',
    reg_email_required: '请填写注册邮箱',
    reg_email_format_error: '邮箱地址有误，请检查',
    reg_email_domain_error: '仅允许使用 @connect.ust.hk 或 @ust.hk 域名的邮箱注册',
    reg_email_already_registered: '该邮箱已注册，请直接登录',
    reg_verification_code_sent: '验证码已成功发送！若未收到，请检查垃圾邮件或稍后重试',
    reg_verification_code_too_frequent: '验证码发送过于频繁，请稍后再试',
    reg_verification_code_invalid: '验证码无效或已过期',
    reg_network_error: '网络异常，请稍后重试',
    reg_slogan: '注册账号',
    reg_username_required: '请输入名称',
    reg_username_max_length: '名称不能超过40位字符',
    reg_username_placeholder: '请输入您的姓名或昵称',
    reg_email_placeholder: '需使用 @connect.ust.hk 或 @ust.hk 邮箱',
    reg_password_placeholder: '8-15位（含大小写字母、数字及符号）',
    reg_confirm_password_placeholder: '请再次输入密码以确认',
    reg_verification_code_placeholder: '请输入 6 位邮件验证码',
    reg_send_code_button: '发送',
    reg_submit_button: '注册提交',
    reg_success: '注册成功',
    reg_failed: '注册失败',
    reg_domain_restriction_notice: '目前仅限 @connect.ust.hk 或 @ust.hk 邮箱注册。更多域名支持，敬请期待',
    // 邀请注册相关
    invite_code_placeholder: '请输入 6 位邀请码',
    invite_code_required: '请输入邀请码',
    invite_code_format_error: '邀请码必须为 6 位数字或字母',
    invite_code_invalid: '邀请码无效，请检查后重试',
    invite_code_exhausted: '该邀请码已达到使用次数上限',
    invite_notice: '请通过扫码或专用网址访问此邀请注册页面',
    invite_email_placeholder: '请填写注册邮箱',
    // 找回密码相关
    pwd_find_slogan: '找回密码',
    pwd_find_email_placeholder: '请输入注册邮箱',
    pwd_find_email_required: '请填写邮箱',
    pwd_find_email_format_error: '邮箱地址有误，请检查',
    pwd_find_password_placeholder: '8-15位（含大小写字母、数字及符号）',
    pwd_find_password_required: '请输入密码',
    pwd_find_password_format_error: '请输入8-15位含大写、小写字母、数字和特殊符号的密码',
    pwd_find_confirm_password_placeholder: '请再次输入密码以确认',
    pwd_find_confirm_password_mismatch: '密码不一致，请重试',
    pwd_find_verification_code_placeholder: '请输入 6 位邮件验证码',
    pwd_find_verification_code_invalid: '验证码无效或已过期',
    pwd_find_send_code_button: '发送验证码',
    pwd_find_submit_button: '确认',
    pwd_find_success: '密码重置成功',
    pwd_find_failed: '密码重置失败',
    pwd_find_verification_code_sent: '找回密码的验证码已成功发送！若未收到，请检查垃圾邮件或稍后重试',
    pwd_reset_verification_code_sent: '重置密码的验证码已成功发送！若未收到，请检查垃圾邮件或稍后重试',
    pwd_find_verification_code_too_frequent: '验证码发送过于频繁，请稍后再试',
    pwd_find_network_error: '网络异常，请稍后重试',
    pwd_find_email_not_found: '该邮箱未注册。请检查输入或注册新账户',
    pwd_find_password_duplication: '新密码不能与历史密码相同',
    ...(language_h5['zh-CN'] || {}),
    // Meeting Assistant
    assistant_landing_title: '港会通  会议助手',
    assistant_landing_subtitle: 'AI 驱动会议智理，重构办公协作效率',
    assistant_input_placeholder: '请输入会议处理需求...',
    assistant_thinking: '思考中...',
    assistant_error: '获取回复失败，请重试',
    assistant_delete_confirm_title: '删除此会话？',
    assistant_delete_confirm_content: '该会话将被永久删除，不可恢复及撤销',
    assistant_delete_success: '删除成功',
    assistant_history_title: '历史记录',
    assistant_loading_history: '正在加载对话记录...',
    assistant_no_history: '暂无对话记录',
    assistant_shift_enter_hint: 'Shift+Enter 换行',
    // 热词
    hot_words_title: '热词',
    hot_words_subtitle: '专属词汇，优先识别，提升识别与翻译准确性',
    hot_words_guide_title: '使用指南',
    hot_words_guide_desc: '添加热词前，请先阅读以下规则，以确保最佳识别效果',
    hot_words_rule_1_title: '输入格式规则',
    hot_words_rule_1_desc: '右侧输入框内，每行代表且仅限填写一个热词',
    hot_words_rule_2_title: '热词数量上限',
    hot_words_rule_2_desc: '最多支持添加300个热词，超出部分将不生效',
    hot_words_rule_3_title: '热词长度限制',
    hot_words_rule_3_desc: '单个热词的字符长度不超过30个汉字或英文单词',
    hot_words_rule_4_title: '输入字符规范',
    hot_words_rule_4_desc: "仅支持输入文字、空格与以下三个符号：连字符（-）、& 符号（&）、单引号（'），不支持其他标点符号",
    hot_words_rule_5_title: '数字符号处理',
    hot_words_rule_5_desc: '热词中包含阿拉伯数字或特殊符号，请用对应的汉字或读音替换。示例："大湾区2026峰会"，建议修改为"大湾区二零二六峰会"',
    hot_words_rule_6_title: '无效词汇规避',
    hot_words_rule_6_desc: '优先添加品牌名、专有名词、人名等关键词汇，提升识别精准度。避免添加单字或无意义的口语高频词，防止降低整体识别准确率',
    hot_words_custom_label: '自定义热词',
    hot_words_input_placeholder: '热词1\n热词2',
    hot_words_undo_changes: '撤销更改',
    hot_words_save: '保存',
    hot_words_save_success: '保存成功',
    hot_words_error_exists: '热词已存在，无法重复添加',
    hot_words_error_invalid_chars: '热词包含不符合规范的字符',
    hot_words_error_too_long: '单个热词字符长度超出限制',
    hot_words_error_too_many: '热词总数量已达到上限',
    hot_words_save_error: '保存热词失败',
    meeting_download_starting: '文件下载中...0%',
    meeting_download_progress: '下载中{percent}%',
    meeting_download_complete: '下载完成 100%',
    meeting_download_failed: '下载失败',
    term_of_use_title: '使用条款',
    term_of_use_content:
      '本应用程序仅供信息参考之用，不得将其作为作出具有法律约束力决策的依据。建议用户通过官方渠道核实关键信息，并遵守所有相关的数据隐私与道德准则。本应用程序明确声明，不对所提供信息的不准确或不当使用承担任何责任。',
  },
  'zh-HK': {
    ...(language['zh-HK'] || {}),
    meeting_type_general: '一般會議',
    meeting_type_social_media: '社交媒體',
    meeting_type_government_gazette: '政府公報',
    upload_audio: '上傳音/視頻',
    record_audio: '錄製音頻',
    transcribe_audio: '即時傳譯',
    start: '開始',
    meeting_name_placeholder: '會議_HKGAI_{date}',
    loading_meetings: '正在加載會議列表...',
    generating_summary: '正在生成摘要，請稍候...',
    loading_summary: '正在加載會議總結...',
    meeting_summary_saved: '會議紀要已儲存',
    meeting_name_saved: '會議名稱已儲存',
    meeting_transcript_saved: '會議轉錄已儲存',
    sidebar_my_meetings: '我的會議',
    sidebar_my_favorites: '我的收藏',
    sidebar_my_shares: '我的長文',
    sidebar_recycle_bin: '回收站',
    sidebar_hot_words: '我的熱詞',
    sidebar_meeting_assistant: '會議助手',
    sidebar_all_chat: '查看全部',
    sidebar_home: '首頁',
    sidebar_help: '幫助',
    sidebar_account_user: '用戶',
    sidebar_account_free_plan: '免費版',
    sidebar_account_pro_plan: '專業版',
    sidebar_account_advanced_plan: '高級版',
    sidebar_account_balance: '{balance} 積分',
    sidebar_account_balance_label: '{plan}，剩餘 {balance} 積分',
    sidebar_account_usage: '{remaining}/{allowance} 積分',
    sidebar_account_open_menu: '開啟帳戶選單',
    sidebar_account_download_desktop: '下載桌面應用程式',
    sidebar_account_about_plan: '關於計劃',
    sidebar_account_quota_label: '{plan}，剩餘 {remaining}/{allowance} 積分',
    home_slogan: '多語隨心',
    home_slogan_highlight: '溝通無界',
    meeting_summary: '會議總結',
    meeting_audio: '會議音/視頻',
    layout_head_tutorial: '使用指引',
    layout_head_it_support: '技術支援',
    it_support_time: '支持時間：周一至周五（除公共假期）：上午9:00至下午6:00',
    it_support_language: '支持語言：英語及普通話',
    exit_modal_password_expired_content: '密碼過期，請重置密碼',
    exit_modal_password_expired_button: '重置',
    translate_error: '翻譯失敗，請重試',
    translating_to: '正在翻譯為',
    // meeting
    meeting_no_summary: '暫無會議總結',
    meeting_refresh_summary: '刷新會議總結',
    meeting_summary_loading: '正在載入會議總結',
    meeting_transcribe_failed: '轉寫失敗，請點選右上角重試',
    meeting_transcribing: '正在轉寫中，請稍候...',
    meeting_reload_summary_error: '會議總結刷新失敗',
    // 反馈相关
    feedback_title: '請為我們的產品滿意度打分',
    feedback_audio_upload_processing: '上傳與處理音頻',
    feedback_audio_to_text_accuracy: '音頻轉文字準確性',
    feedback_summary_quality: '會議紀要生成質量',
    feedback_interface_interaction: '界面與交互',
    feedback_other_issues: '其它問題',
    feedback_title_why: '原因?',
    feedback_input_placeholder: '請在此輸入反饋內容',
    feedback_input_placeholder_required: '請在此輸入反饋內容（必填）',
    feedback_success: '反饋成功',
    feedback_fail: '反饋失敗',
    feedback_btn_text: '反饋',
    // 删除确认相关
    confirm_delete: '刪除',
    cancel: '取消',
    meeting_delete_error: '刪除失敗，請重試',
    // 回收站相关
    meeting_move_to_recycle_bin_title: '移動到回收站',
    meeting_move_to_recycle_bin_content: '確定要將會議 "{meetingName}" 移動到回收站嗎？',
    move_to_recycle_bin: '移動到回收站',
    meeting_moved_to_recycle_bin: '已移動到回收站',
    meeting_permanent_delete_title: '永久刪除',
    meeting_permanent_delete_content: '確定要永久刪除會議 "{meetingName}" 嗎？此操作不可撤銷。',
    permanent_delete: '永久刪除',
    meeting_permanent_delete_success: '永久刪除成功',
    meeting_restore_title: '恢復會議',
    meeting_restore_content: '確定要恢復會議 "{meetingName}" 嗎？',
    restore: '恢復',
    meeting_restored: '會議已恢復',
    meeting_restore: '恢復',
    meeting_permanent_delete: '永久刪除',
    meeting_move_to_trash: '會議已移至回收站',
    meeting_restore_success: '會議恢復成功',
    // 回收站批量操作
    recycle_bin_select_all: '全選',
    recycle_bin_delete_selected: '刪除所選',
    recycle_bin_no_items_selected: '未選擇任何項目',
    recycle_bin_delete_selected_confirm_title: '確認刪除所選',
    recycle_bin_delete_selected_confirm_content_one: '確定要永久刪除所選的 {count} 項嗎？此操作不可撤銷。',
    recycle_bin_delete_selected_confirm_content: '確定要永久刪除所選的 {count} 項嗎？此操作不可撤銷。',
    recycle_bin_delete_selected_success: '所選項目刪除成功',
    // 收藏相关
    meeting_favorite: '收藏',
    meeting_unfavorite: '取消收藏',
    meeting_favorited: '已收藏',
    meeting_unfavorited: '已取消收藏',
    // 功能卡片
    card_badge_record: '會議錄音整理',
    card_title_record: '開始錄製',
    card_desc_record_line1: '會中錄製，會後紀要',
    card_desc_record_line2: '多人對話精準區分，語篇規整一目了然',
    card_badge_upload: '音頻/視頻處理',
    card_title_upload: '開始上傳',
    card_desc_upload_line1: '提取文字，歸納總結',
    card_desc_upload_line2: '精準識別極速出稿，智能紀要條理清晰',
    card_badge_transcribe: '即時轉錄傳譯',
    card_title_transcribe: '開始同傳',
    card_desc_transcribe_line1: '邊錄邊轉，同步翻譯',
    card_desc_transcribe_line2: '粵普英自動識別，多端同步即時查閱',
    // 跨会议总结页面
    cross_summary_title: '跨會議總結',
    cross_summary_description: '選擇多個會議，生成綜合性長篇稿件',
    cross_summary_generate: '開始生成',
    cross_summary_generating: '生成中...',
    cross_summary_select_all: '全選',
    cross_summary_select_warning: '請至少選擇一個會議',
    cross_summary_selected: '已選擇 {count} 個會議',
    cross_summary_generate_success: '跨會議總結生成成功',
    cross_summary_generate_error: '生成跨會議總結失敗',
    cross_summary_no_meetings: '暫無可用的會議',
    // 生成配置对话框
    cross_summary_config_title: '配置跨會議總結',
    cross_summary_confirm_generate: '確認生成',
    cross_summary_title_label: '文章標題',
    cross_summary_title_placeholder: '請輸入生成文章的標題',
    cross_summary_title_required: '請輸入文章標題',
    cross_summary_title_max_length: '標題不能超過100個字符',
    cross_summary_type_label: '會議類型',
    cross_summary_type_placeholder: '請選擇會議類型',
    cross_summary_type_required: '請選擇會議類型',
    cross_summary_selected_meetings: '已選擇的會議',
    // 文章编辑器相关
    enter_title: '請輸入標題',
    untitled_article: '無標題文章',
    last_saved: '上次保存',
    copy: '複製',
    edit: '編輯',
    delete: '刪除',
    regenerate: '重新生成',
    download: '下載',
    save: '保存',
    save_success: '保存成功',
    save_error: '保存失敗',
    copy_success: '複製成功',
    copy_error: '複製失敗',
    download_success: '下載成功',
    download_error: '下載失敗',
    no_content_to_download: '沒有內容可下載',
    generating_article: '正在生長文',
    confirm_regenerate: '確認重新生成',
    confirm_regenerate_content: '重新生成將覆蓋當前內容，確定繼續嗎？',
    unsaved_changes: '未保存的更改',
    unsaved_changes_content: '您有未保存的更改，確定要離開嗎？',
    original_language: '原文',
    source_meetings_title: '基於以下會議生成',
    meeting_card_tooltip: '點擊查看會議',
    // 长文相关
    article_delete_confirm_title: '確認刪除',
    article_delete_confirm_content: '確定要刪除這篇長文嗎？刪除後可在回收站中恢復。',
    article_permanent_delete_title: '確認永久刪除',
    article_permanent_delete_content: '永久刪除後無法恢復，確定要刪除這篇長文嗎？',
    article_restore_tooltip: '恢復',
    article_permanent_delete_tooltip: '永久刪除',
    no_saved_articles: '暫無保存的長文',
    no_favorites: '暫無收藏內容',
    // 录音相关
    meeting_create_title: '上傳音頻 / 視頻文件以生成轉錄文本',
    meeting_create_description: '根據音訊 / 視訊檔案的大小，處理和轉錄大約需要 10-15 分鐘。（1小時音頻/視頻）',
    meeting_upload_description: '點選或拖曳WAV、MP3、 M4A、MP4 檔案到此處上傳',
    meeting_upload_limit_msg: '音頻檔案大小不能超過600MB，視頻檔案大小不能超過500MB',
    meeting_name_limit_length: '不能超过80个字符',
    meeting_time_future_error: '會議時間不能大於當前時間',
    meeting_file_upload_error: '文件上傳失敗，請重試',
    meeting_name_required: '請輸入會議標題',
    meeting_upload_file_required: '請先錄製或上傳文件',
    meeting_recording_required: '請先錄製音頻',
    meeting_upload_file_required_recording: '音頻錄制中，請確認完成錄制後再提交',
    meeting_audio_size_limit: '音頻檔案大小不能超過600MB',
    meeting_video_size_limit: '視頻檔案大小不能超過500MB',
    meeting_obs_token_error: '獲取上傳憑證失敗，請重試',
    login_status_expired_relogin: '登入狀態已過期，請重新登入',
    meeting_modal_confirm_record_finish_content: '確認完成本次會議錄音?',
    meeting_back_warn_on_recording: '離開將結束本次會議，所有內容無法儲存',
    // 添加麦克风权限相关文本
    meeting_modal_error_permission_denied_title: '麥克風權限被拒絕',
    meeting_modal_error_permission_denied_content: '請在瀏覽器設置中允許訪問麥克風，然後重試。',
    meeting_modal_error_record_open_failed: '打開錄音失敗，請檢查麥克風權限並重試',
    meeting_modal_error_retry: '重試',
    // Transcribe related
    transcribe_translate_button_label: '翻譯',
    transcribe_translate_auto_switch: '自動切換',
    transcribe_speaker_label: '發言人',
    transcribe_empty_placeholder: '即時轉錄內容將顯示在這裡',
    meeting_translation_fetch_error: '獲取翻譯失敗，請重試。',
    transcribe_connection_lost: '即時轉錄已中斷，本地音訊仍在錄製。',
    transcribe_connection_retry: '重試轉錄',
    transcribe_connection_retry_failed: '無法重新啟動轉錄，請檢查網絡後重試。',
    transcribe_download_audio: '下載音訊',
    transcribe_download_end_title: '下載音訊並結束會議？',
    transcribe_download_end_content: '下載將停止錄音並結束本次會議，音訊只會儲存至當前裝置。',
    transcribe_download_end_confirm: '下載並結束',
    transcribe_audio_download_error: '無法下載已錄製的音訊。',
    transcribe_recording_preparing: '正在準備錄音……',
    transcribe_recording_preparing_description: '正在產生本地 WAV 檔案，請保持此頁面開啟。',
    transcribe_recording_uploading: '正在上傳錄音……',
    transcribe_recording_uploading_description: '錄音正在上傳，請保持此頁面開啟。',
    transcribe_meeting_creating: '正在建立會議……',
    transcribe_meeting_creating_description: '錄音已上傳，正在儲存會議資料。',
    transcribe_recording_upload_failed: '錄音上傳失敗',
    transcribe_recording_upload_failed_description: '錄音仍保留在此瀏覽器中。您可以重試上傳或下載備份。',
    transcribe_meeting_create_failed: '會議建立失敗',
    transcribe_meeting_create_failed_description: '錄音已成功上傳。您可以重試建立會議，無需再次上傳。',
    transcribe_retry_upload: '重試上傳',
    transcribe_retry_create: '重試建立會議',
    transcribe_finalizing_leave_content: '錄音尚未處理完成。現在離開可能會遺失本地錄音，請先下載備份。',
    // Meeting Detail
    meeting_detail_tab_transcript: '會議轉錄',
    meeting_detail_tab_summary_editor: '編輯&問答',
    meeting_formal_language: '書面語',
    meeting_total_count: '總字數',
    meeting_detail_chat_input_placeholder: '請輸入編輯 & 問答需求',
    meeting_detail_chat_input_hint: 'Shift+Enter 換行',
    meeting_detail_chat_editing: '智能編輯中...',
    meeting_detail_chat_text_copy: '複製',
    meeting_detail_chat_text_copied: '已複製',
    meeting_detail_chat_text_edit: '編輯',
    meeting_detail_chat_upload_file: '上傳文件（txt、doc、docx、pdf）',
    meeting_detail_chat_uploading: '上傳中...',
    meeting_detail_chat_upload_error: '上傳失敗，點擊重試',
    meeting_detail_chat_upload_file_types_error: '僅支持txt、doc、docx、pdf格式。',
    meeting_detail_chat_max_file_size_error: '文件大小不能超過5MB',
    meeting_detail_chat_max_file_count_error: '最多允許上傳1個文件',
    meeting_detail_chat_input_required_with_file: '請輸入您的編輯需求',
    meeting_detail_chat_stop_using_file: '不再圍繞這個文件問答',
    meeting_detail_chat_mode_agent: '智能體模式',
    meeting_detail_chat_mode_ask: '問答模式',
    meeting_detail_chat_stop_generating: '停止生成',
    meeting_detail_chat_stopping: '正在停止',
    meeting_detail_chat_generation_stopped: '已停止生成',
    meeting_detail_chat_stop_failed: '停止失敗',
    meeting_detail_chat_retry_stop: '重試停止',
    meeting_detail_chat_commit_failed: '會議紀要儲存失敗，修改已還原',
    meeting_tooltip_send_mail: '發送郵件',
    meeting_placeholder_text: '開始輸入...',
    meeting_translate_success: '翻譯為{langName}成功',
    translate_lang_en: '英文',
    translate_lang_zh_cn: '簡體中文',
    translate_lang_zh_hk: '繁體中文',
    // 發送郵件彈窗
    send_email_modal_title: '發送會議紀要',
    send_email_recipients_label: '收件人',
    send_email_sumarry_label: '會議紀要',
    send_email_recipients_placeholder: '請輸入郵箱地址，多個郵箱用英文逗號或英文分号或回车分隔',
    send_email_recipients_hint: '單次最多新增 50 個收件人，多個郵箱請用英文逗號或英文分号或回车分隔',
    send_email_send_button: '發送',
    send_email_max_recipients_toast: '單次最多新增 50 個收件人',
    send_email_daily_limit_toast: '今日發送量達 300 封上限',
    send_email_success_toast: '會議紀要已成功傳送至收件人',
    send_email_failed_toast: '郵件傳送失敗，請檢查郵件格式或稍後重試',
    // 會員積分
    membership_credits_modal_title: '我的積分用量',
    membership_credits_modal_subtitle: '查看本週期剩餘積分及使用情況。',
    membership_credits_close: '關閉',
    membership_credits_overview_label: '積分餘額概覽',
    membership_credits_left: '剩餘積分',
    membership_credits_plan_badge: '{plan} · 每月 {allowance}',
    membership_credits_audio_equivalent: '≈ {time} 音訊 · 錄音或轉錄 1 分鐘消耗 1 積分',
    membership_credits_resets_in: '將在 {days} 天後重置',
    membership_credits_expiry: '會員有效期至 {date}',
    membership_credits_used_label: '已使用 {used}/{allowance} 積分',
    membership_credits_used_percentage: '{percent}% 已用',
    membership_credits_breakdown_title: '積分使用去向',
    membership_credits_rate: '1 積分 = 1 分鐘',
    membership_credits_cycle_used: '本週期 · 已使用 {used}',
    membership_credits_cycle_used_with_period: '本週期（{start} – {end}）· 已使用 {used}',
    membership_credits_service: '服務',
    membership_credits_time: '時長',
    membership_credits_credits: '積分',
    membership_credits_service_file: '檔案轉錄',
    membership_credits_service_recording: '錄音',
    membership_credits_service_live: '即時傳譯',
    membership_credits_note: '每場會議的記錄可在「使用詳情」中查看。',
    membership_credits_manage_subscription: '管理訂閱',
    membership_credits_usage_details: '積分使用詳情',
    membership_credits_time_hours_minutes: '{hours} 小時 {minutes} 分鐘',
    membership_credits_time_minutes: '{minutes} 分鐘',
    membership_credits_plan_badge_live: '{plan} · {allowance} {period}',
    membership_credits_per_cycle: '每 31 天',
    membership_credits_per_month: '每月',
    membership_credits_balance_hint: '所有有效積分批次的可用總額',
    membership_credits_next_cycle: '下次發放/重置',
    membership_credits_source_free: '免費積分',
    membership_credits_source_subscription: '訂閱積分',
    membership_credits_source_purchase: '購買積分',
    membership_credits_source_other: '積分',
    membership_credits_rules_title: '積分使用規則',
    membership_credits_rule_file: '檔案轉錄：1 積分 / 1 分鐘',
    membership_credits_rule_recording: '錄音轉錄：1 積分 / 1 分鐘',
    membership_credits_rule_live: '即時傳譯：1 積分 / 1 分鐘',
    membership_credits_expiring_title: '即將到期的積分',
    membership_credits_expiring_hint: '最多顯示 10 個有效批次',
    membership_credits_no_expirations: '暫無即將到期的有效積分批次。',
    membership_credits_load_error: '無法載入會員及積分詳情。',
    membership_credits_retry: '重試',
    membership_credits_transactions_title: '積分使用詳情',
    membership_credits_transactions_subtitle: '查看積分發放、使用、過期及調整記錄。',
    membership_credits_transactions_error: '無法載入積分流水。',
    membership_credits_transactions_empty: '暫無積分流水。',
    membership_credits_transaction_time: '時間',
    membership_credits_transaction_detail: '詳情',
    membership_credits_transaction_source: '來源',
    membership_credits_transaction_type: '類型',
    membership_credits_transaction_change: '變動',
    membership_credits_transaction_balance: '變動後餘額',
    membership_credits_transaction_grant: '發放',
    membership_credits_transaction_consume: '使用',
    membership_credits_transaction_expire: '過期',
    membership_credits_transaction_adjust: '調整',
    credits_check_failed_title: '無法查詢積分',
    credits_check_failed_content: '暫時無法確認您的最新積分餘額，請重試。',
    credits_insufficient_title: '積分不足',
    credits_insufficient_empty: '目前積分餘額不足，請取得更多積分後再次嘗試。',
    credits_insufficient_required: '本次提交預計需消耗 {required} 積分，您目前可用 {balance} 積分，請取得更多積分後再次嘗試。',
    credits_live_transcription_low_title: '積分即將用盡',
    credits_live_transcription_low_content: '目前剩餘積分為「{balance}」，預計可使用轉錄時長為「{duration}」。',
    credits_live_transcription_ended: '目前剩餘積分為「{balance}」，會議已自動結束。',
    credits_dialog_ok: '知道了',
    credits_estimate_transcription: '本次轉錄預計將使用 {credits} 積分。',
    credits_recording_available_time: '可用錄音時長：{time}',
    meeting_media_duration_error: '無法讀取音訊或影片時長，請選擇其他檔案。',
    // 注册相关
    login_download_slogan: '線上線下會議，就用客戶端',
    login_download_windows_button: 'Windows 下載',
    login_download_mac_button: 'MacOS 下載',
    login_form_reg_button: '註冊帳號',
    reg_password_required: '請輸入密碼',
    reg_password_format_error: '請輸入8-15位含大寫、小寫字母、數字和特殊符號的密碼',
    reg_confirm_password_mismatch: '密碼不一致，請重試',
    reg_email_required: '請填寫註冊郵箱',
    reg_email_format_error: '電郵地址有誤，請檢查',
    reg_email_domain_error: '僅允許使用 @connect.ust.hk 或 @ust.hk 域名的電郵地址註冊',
    reg_email_already_registered: '該電郵地址已註冊，請直接登入',
    reg_verification_code_sent: '驗證碼已成功發送！若未收到，請檢查垃圾郵件或稍後重試。',
    reg_verification_code_too_frequent: '驗證碼發送過於頻繁，請稍後再試',
    reg_verification_code_invalid: '驗證碼無效或已過期',
    reg_network_error: '網絡異常，請稍後重試',
    reg_slogan: '註冊帳號',
    reg_username_required: '請輸入名稱',
    reg_username_max_length: '名稱不能超過40位字符',
    reg_username_placeholder: '請輸入您的姓名或暱稱',
    reg_email_placeholder: '需使用 @connect.ust.hk 或 @ust.hk 郵箱',
    reg_password_placeholder: '8-15位（含大小寫字母、數字及符號）',
    reg_confirm_password_placeholder: '請再次輸入密碼以確認',
    reg_verification_code_placeholder: '請輸入 6 位郵件驗證碼',
    reg_send_code_button: '發送',
    reg_submit_button: '註冊提交',
    reg_success: '註冊成功',
    reg_failed: '註冊失敗',
    reg_domain_restriction_notice: '目前僅限 @connect.ust.hk 或 @ust.hk 電郵註冊。更多網域支持，敬請期待',
    // 邀請註冊相關
    invite_code_placeholder: '請輸入 6 位邀請碼',
    invite_code_required: '請輸入邀請碼',
    invite_code_format_error: '邀請碼必須為 6 位數字或字母',
    invite_code_invalid: '邀請碼無效，請檢查後重試',
    invite_code_exhausted: '該邀請碼已達到使用次數上限',
    invite_notice: '請通過掃碼或專用網址訪問此邀請註冊頁面',
    invite_email_placeholder: '請填寫註冊郵箱',
    // 找回密码相关
    pwd_find_slogan: '找回密碼',
    pwd_find_email_placeholder: '請輸入註冊郵箱',
    pwd_find_email_required: '請填寫郵箱',
    pwd_find_email_format_error: '電郵地址有誤，請檢查',
    pwd_find_password_placeholder: '8-15位（含大小寫字母、數字及符號）',
    pwd_find_password_required: '請輸入密碼',
    pwd_find_password_format_error: '請輸入8-15位含大寫、小寫字母、數字和特殊符號的密碼',
    pwd_find_confirm_password_placeholder: '請再次輸入密碼以確認',
    pwd_find_confirm_password_mismatch: '密碼不一致，請重試',
    pwd_find_verification_code_placeholder: '請輸入 6 位郵件驗證碼',
    pwd_find_verification_code_invalid: '驗證碼無效或已過期',
    pwd_find_send_code_button: '發送驗證碼',
    pwd_find_submit_button: '確定',
    pwd_find_success: '密碼重置成功',
    pwd_find_failed: '密碼重置失敗',
    pwd_find_verification_code_sent: '找回密碼的驗證碼已成功發送！若未收到，請檢查垃圾郵件或稍後重試',
    pwd_reset_verification_code_sent: '重設密碼的驗證碼已成功發送！若未收到，請檢查垃圾郵件或稍後重試',
    pwd_find_verification_code_too_frequent: '驗證碼發送過於頻繁，請稍後再試',
    pwd_find_network_error: '網絡異常，請稍後重試',
    pwd_find_email_not_found: '該電郵未註冊。請檢查輸入或註冊新帳戶',
    pwd_find_password_duplication: '新密碼不能與歷史密碼相同',
    ...(language_h5['zh-HK'] || {}),
    // Meeting Assistant
    assistant_landing_title: '港會通  會議助手',
    assistant_landing_subtitle: 'AI 驅動會議智理，重構辦公協作效率',
    assistant_input_placeholder: '請輸入會議處理需求...',
    assistant_thinking: '思考中...',
    assistant_error: '獲取回覆失敗，請重試',
    assistant_delete_confirm_title: '刪除此會話？',
    assistant_delete_confirm_content: '該會話將被永久刪除，不可恢復及撤銷',
    assistant_delete_success: '刪除成功',
    assistant_history_title: '歷史記錄',
    assistant_loading_history: '正在載入對話記錄...',
    assistant_no_history: '暫無對話記錄',
    assistant_shift_enter_hint: 'Shift+Enter 換行',
    // 熱詞
    hot_words_title: '熱詞',
    hot_words_subtitle: '專屬詞彙，優先識別，提升識別與翻譯準確性',
    hot_words_guide_title: '使用指南',
    hot_words_guide_desc: '添加熱詞前，請先閱讀以下規則，以確保最佳識別效果',
    hot_words_rule_1_title: '輸入格式規則',
    hot_words_rule_1_desc: '右側輸入框內，每行代表且僅限填寫一個熱詞',
    hot_words_rule_2_title: '熱詞數量上限',
    hot_words_rule_2_desc: '最多支援添加 300 個熱詞，超出部分將不生效',
    hot_words_rule_3_title: '熱詞長度限制',
    hot_words_rule_3_desc: '單個熱詞的字元長度不超過30個漢字或英文單詞',
    hot_words_rule_4_title: '輸入字元規範',
    hot_words_rule_4_desc: "僅支援輸入文字、空格與以下三個符號：連字號（-）、& 符號（&）、單引號（'），不支援其他標點符號",
    hot_words_rule_5_title: '數字符號處理',
    hot_words_rule_5_desc: '熱詞中包含阿拉伯數字或特殊符號，請用對應的漢字或讀音替換。示例：「大灣區 2026 峰會」，建議修改為「大灣區二零二六峰會」',
    hot_words_rule_6_title: '無效詞彙规避',
    hot_words_rule_6_desc: '優先添加品牌名、專有名詞、人名等關鍵詞彙，提升識別精準度。避免添加單字或無意義的口語高頻詞，防止降低整體識別準確率',
    hot_words_custom_label: '自定義熱詞',
    hot_words_input_placeholder: '熱詞1\n熱詞2',
    hot_words_undo_changes: '撤銷變更',
    hot_words_save: '儲存',
    hot_words_save_success: '儲存成功',
    hot_words_error_exists: '熱詞已存在，無法重複新增',
    hot_words_error_invalid_chars: '熱詞包含不符合規範的字元',
    hot_words_error_too_long: '單個熱詞字元長度超出限制',
    hot_words_error_too_many: '熱詞總數已達上限',
    hot_words_save_error: '儲存熱詞失敗',
    meeting_download_starting: '文件下載中...0%',
    meeting_download_progress: '下載中{percent}%',
    meeting_download_complete: '下載完成 100%',
    meeting_download_failed: '下載失敗',
    term_of_use_title: '使用條款',
    term_of_use_content:
      '本應用程式僅供資訊參考之用，不得將其作為作出具法律約束力決策之依據。建議使用者透過官方管道核實關鍵資訊，並遵守所有相關之資料隱私與道德準則。本應用程式明確聲明，不對所提供資訊之不準確或不當使用承擔任何責任。',
  },
};

export default i18n;
